module.exports = __webpack_public_path__ + "static/media/c57.cf6a4b48.png";